export class TierLimitError extends Error {}

export class CourseLimitError extends TierLimitError {
  static readonly CODE = 'COURSE_LIMIT_REACHED';
}

export class UserLimitError extends TierLimitError {
  static readonly CODE = 'USER_LIMIT_REACHED';
}

export class BulkImportNotAllowedError extends TierLimitError {
  static readonly CODE = 'BULK_IMPORT_NOT_ALLOWED';
}
